import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";

import interviewVault from "../assets/projects/interviewVault.png";
import portfolio from "../assets/projects/portfolio.png";
import bookShow from "../assets/projects/bookshow.png";
import adminEmp from "../assets/projects/adminEmployee.png";

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Works</strong>
        </h1>

        <p style={{ color: "white" }}>
          Here are a few projects I&apos;ve worked on recently.
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {/* InterviewVault - FIRST */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={interviewVault}
              isBlog={false}
              title="InterviewVault"
              description="InterviewVault is a full-stack platform for sharing and exploring corporate and government interview experiences. Built with Next.js, Node.js, and MongoDB, it features secure authentication with NextAuth, protected routes, and a responsive dashboard with search, pagination, and status-based filtering. The platform is optimized for SEO using SSR and deployed on Vercel for high performance."
              ghLink="https://github.com/dhiraj002/InterviewVault"
              demoLink="https://interviewvault-ubft.vercel.app/"
            />
          </Col>

          {/* Portfolio - SECOND */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="Personal Portfolio"
              description="A modern and responsive personal portfolio built with React to showcase my skills, projects, and experience. It highlights component-based architecture, clean UI design, and smooth navigation, along with GitHub integration and project case studies for a recruiter-friendly experience."
              demoLink="https://portfolio-website02.vercel.app/"
            />
          </Col>

          {/* BookShow - THIRD */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bookShow}
              isBlog={false}
              title="BookShow"
              description="BookShow is a React-based web application that integrates the Google Books API to help users discover and explore books across multiple genres. It includes real-time search, detailed book information, and dynamic pagination for a smooth browsing experience."
              ghLink="https://github.com/dhiraj002/BooksShow"
            />
          </Col>

          {/* Employee Management - FOURTH */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={adminEmp}
              isBlog={false}
              title="Employee Management System"
              description="A React-based employee management system designed for task assignment and tracking. It uses localStorage for authentication and session persistence, allowing managers to assign tasks, monitor progress, and manage employees efficiently through a clean and intuitive interface."
              ghLink="https://github.com/dhiraj002/Employee_Management_System"
              demoLink="https://employee-management-system002.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Projects;
